import { render, staticRenderFns } from "./ToolsCatalogModal.vue?vue&type=template&id=6450126e&"
import script from "./ToolsCatalogModal.vue?vue&type=script&lang=js&"
export * from "./ToolsCatalogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports